import i18n from "i18next";

import { initReactI18next } from "react-i18next";

import en from "./en.json";
import en_US from "./en_US.json";
import nl from "./nl.json";
import sr from "./sr.json";
import fr from "./fr.json";
import de from "./de.json";
import pt from "./pt.json";
import es from "./es.json";
import ja from "./ja.json";
import pl from "./pl.json";
import it from "./it.json";

const resources = { en, en_US, nl, sr, fr, de, pt, es, ja, pl, it } as const;

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: typeof en;
    resources: (typeof resources)["en"];
  }
}

i18n.use(initReactI18next).init({
  resources,

  debug: process.env.NODE_ENV !== "production",

  lng: "en",
  fallbackLng: "en",

  keySeparator: ".",

  interpolation: {
    escapeValue: false,
  },
});
